var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"body-text text--text",domProps:{"innerHTML":_vm._s(_vm.action.Detail)}})}
var staticRenderFns = []

export { render, staticRenderFns }